import React from 'react';
import '../assets/styles/Modal.scss'; 

const Modal = ({ children, onClose }: { children: React.ReactNode; onClose: () => void }) => (
  <div className="modal-overlay" onClick={onClose}>
    <div className="modal-content" onClick={e => e.stopPropagation()}>
      <button className="close-btn" onClick={onClose}>×</button>
      {children}
    </div>
  </div>
);

export default Modal;
